import { render, staticRenderFns } from "./HeaderCourse.vue?vue&type=template&id=09a6fd46&scoped=true&"
import script from "./HeaderCourse.vue?vue&type=script&lang=js&"
export * from "./HeaderCourse.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCourse.vue?vue&type=style&index=0&id=09a6fd46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6fd46",
  null
  
)

export default component.exports